import GetEventByEventIdentifierRequestModelBase from '../_generated/modelBases/get-event-by-event-identifier-request-model-base';

export default class GetEventByEventIdentifierRequestModel extends GetEventByEventIdentifierRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
